export default __webpack_public_path__ + "../staticImages/sgt_geschenke-260.png";